export class Logger {
	static log(...messages: any[]) {
		if (window.debugMode) {
			console.log(`[LOG] ${messages.map((m) => JSON.stringify(m)).join(" ")}`);
		}
	}

	static error(...messages: any[]) {
		if (window.debugMode) {
			console.error(
				`[ERROR] ${messages.map((m) => JSON.stringify(m)).join(" ")}`
			);
		}
	}

	static warn(...messages: any[]) {
		if (window.debugMode) {
			console.warn(
				`[WARN] ${messages.map((m) => JSON.stringify(m)).join(" ")}`
			);
		}
	}
}
